// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"654":"b48693b2","722":"19ae38e8"}[chunkId] + ".css";
};